import Colors from '@constants/Colors';
import {
  Agreement02Icon,
  Calendar03Icon,
  CoinsDollarIcon,
  MailOpen02Icon,
  QrCodeIcon,
  UserGroupIcon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react-native';
import { useGetTotalUnreadCount } from '@queries/conversations';
import { type BottomTabNavigationOptions } from '@react-navigation/bottom-tabs';
import { isNative } from '@sunrise-ui/primitives';
import { headerOptionsCreator } from '@utils/screenOptions';
import { Tabs } from 'expo-router';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

export default function TabLayout() {
  const { data: unreadCount = 0 } = useGetTotalUnreadCount('all');

  const screenOptions: BottomTabNavigationOptions = {
    tabBarActiveTintColor: Colors.dark.yellow0,
    tabBarStyle: {
      shadowColor: Colors.dark.yellow0,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 1,
      shadowRadius: isNative ? 5 : 10,
      elevation: 10, // Needed for Android
    },
    tabBarShowLabel: false,
    ...headerOptionsCreator(),
    transitionSpec: {
      animation: 'timing',
      config: {
        duration: 0,
      },
    },
  };

  return (
    <Tabs screenOptions={screenOptions}>
      <Tabs.Screen
        name="events"
        options={{
          tabBarIcon: ({ color }) => (
            <HugeiconsIcon icon={Calendar03Icon} color={color} />
          ),
          headerShown: false,
        }}
      />
      <Tabs.Screen
        name="tokens"
        options={{
          href: null,
          tabBarIcon: ({ color }) => (
            <HugeiconsIcon icon={CoinsDollarIcon} color={color} />
          ),
        }}
      />
      <Tabs.Screen
        name="inbox"
        options={{
          tabBarIcon: ({ color }) => (
            <View>
              <HugeiconsIcon icon={MailOpen02Icon} color={color} />
              {unreadCount > 0 && (
                <View style={styles.badge}>
                  <Text style={styles.badgeText}>
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </Text>
                </View>
              )}
            </View>
          ),
          headerShown: false,
        }}
      />
      <Tabs.Screen
        name="intros"
        options={{
          tabBarIcon: ({ color }) => (
            <HugeiconsIcon icon={Agreement02Icon} color={color} />
          ),
          headerShown: false,
        }}
      />
      <Tabs.Screen
        name="communities"
        options={{
          tabBarIcon: ({ color }) => (
            <HugeiconsIcon icon={UserGroupIcon} color={color} />
          ),
        }}
      />
      <Tabs.Screen
        name="qrcode"
        options={{
          tabBarIcon: ({ color }) => (
            <HugeiconsIcon icon={QrCodeIcon} color={color} />
          ),
        }}
      />
    </Tabs>
  );
}

const styles = StyleSheet.create({
  badge: {
    position: 'absolute',
    right: -8,
    top: -5,
    backgroundColor: Colors.dark.yellow0,
    borderRadius: 10,
    minWidth: 18,
    height: 18,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
    borderWidth: 2,
    borderColor: Colors.dark.purple0,
  },
  badgeText: {
    color: Colors.dark.purple0,
    fontSize: 10,
    fontWeight: 'bold',
  },
});
